import React from "react";
import { View, StyleSheet } from "react-native";
import WorkspaceSidebar from "../../components/chat-companion/WorkspaceSidebar/WorkspaceSidebar";
import { useCompanionThreads } from "../../contexts/CompanionThreadsContext";
import { GENERAL_WORKSPACE_ID } from "../../hooks/useWorkspaceLists";
import CustomText from "../../components/common/general/CustomText/CustomText";
import CustomButton from "../../components/common/general/CustomButton/CustomButton";

const WorkspaceSidebarContainer = () => {
  const {
    generalWorkspaces,
    courseWorkspaces,
    todoWorkspaces,
    learningActivitiesWorkspaces,
    settingsWorkspaces,
    activeWorkspaceId,
    activeThreadId,
    isSidebarCollapsed,
    setIsSidebarCollapsed,
    openWorkspaceId,
    toggleWorkspaceDrawer,
    threadsByWorkspaceId,
    isLoadingCourseWorkspaces,
    previewError,
    refetchPreviewChats,
    onWorkspacePress,
    onThreadSelect,
    onThreadDelete,
    onNewThread,
    onThreadRename,
    onThreadLoadMore,
  } = useCompanionThreads();

  if (previewError) {
    return (
      <View style={styles.errorContainer}>
        <CustomText text={previewError} size="m" useTranslationText={false} style={styles.errorMessage} />
        <CustomButton
          text="Retry"
          onPress={() => void refetchPreviewChats()}
          useTranslationText={false}
          style={styles.retryButton}
        />
      </View>
    );
  }

  return (
    <WorkspaceSidebar
      generalWorkspaces={generalWorkspaces}
      courseWorkspaces={courseWorkspaces}
      todoWorkspaces={todoWorkspaces}
      learningActivitiesWorkspaces={learningActivitiesWorkspaces}
      settingsWorkspaces={settingsWorkspaces}
      activeWorkspaceId={activeWorkspaceId || GENERAL_WORKSPACE_ID}
      onWorkspacePress={onWorkspacePress}
      threadsByWorkspaceId={threadsByWorkspaceId}
      isLoadingCourseWorkspaces={isLoadingCourseWorkspaces}
      onThreadLoadMore={onThreadLoadMore}
      onThreadSelect={onThreadSelect}
      onThreadDelete={onThreadDelete}
      onNewThread={onNewThread}
      onThreadRename={onThreadRename}
      activeThreadId={activeThreadId}
      isSidebarCollapsed={isSidebarCollapsed}
      setIsSidebarCollapsed={setIsSidebarCollapsed}
      openWorkspaceId={openWorkspaceId}
      toggleWorkspaceDrawer={toggleWorkspaceDrawer}
    />
  );
};

const styles = StyleSheet.create({
  errorContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 24,
    minWidth: 67,
  },
  errorMessage: {
    textAlign: "center",
    marginBottom: 16,
  },
  retryButton: {
    minWidth: 120,
  },
});

export default WorkspaceSidebarContainer;
